import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Media',
    path: '/media'
  }, {
    name: 'Writing',
    path: '/writing'
  }, {
    name: 'Ventures',
    path: '/ventures'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  const isActive = (path: string) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };
  return <header className="w-full bg-white shadow-sm sticky top-0 z-50" data-id="element-45">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-46">
        <Link to="/" className="flex items-center" data-id="element-47">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/c6xsg6Mo625scKjodLycdg/AznShawnAlahah_signature_transparent.png" alt="Azn Shawn Alahah" className="h-8 md:h-10 w-auto" data-id="element-48" />
        </Link>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-49">
          {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium ${isActive(link.path) ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600 hover:text-blue-600'}`} data-id="element-50">
              {link.name}
            </Link>)}
        </nav>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-gray-600 focus:outline-none" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-51">
          {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-52" /> : <MenuIcon className="h-6 w-6" data-id="element-53" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white border-t border-gray-100" data-id="element-54">
          <div className="container mx-auto px-4 py-2" data-id="element-55">
            <nav className="flex flex-col space-y-3 py-4" data-id="element-56">
              {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium px-3 py-2 rounded ${isActive(link.path) ? 'text-blue-600 bg-blue-50' : 'text-gray-600 hover:text-blue-600 hover:bg-gray-50'}`} onClick={() => setIsMenuOpen(false)} data-id="element-57">
                  {link.name}
                </Link>)}
            </nav>
          </div>
        </div>}
    </header>;
}